import { useEffect } from "react";

// Closes an open popup on a click outside `ref` or on Escape.
export const useDismiss = (open, close, ref) => {
  useEffect(() => {
    if (!open) return undefined;
    const onMouseDown = (event) => {
      if (!ref.current?.contains(event.target)) close();
    };
    const onKeyDown = (event) => event.key === "Escape" && close();
    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, close, ref]);
};
